import React, {useState } from 'react';
import {makeStyles, Button, Typography } from "@material-ui/core";
import { Formik, Form, Field } from 'formik';
import { string, object } from 'yup';
import FormikTextField from '../../components/formikcomponent/TextField';
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import {StatusCodes} from 'http-status-codes';
const useStyles = makeStyles(theme => ({
    primaryBtn: {
        color: "white", backgroundColor: theme.palette.primary.main, border: "1px solid blue", width: "40%", borderRadius: "25px", padding: "8px",
        '&:hover': { backgroundColor: theme.palette.primary.main, color: theme.palette.text.textPrimaryColor, border: "1px solid blue" }
    },
    errorMessage: { color: '#f44336' },
    cardFooter: { justifyContent: "flex-end", padding: "16px 0px", margin: "30px 0 20px" },
    icnColor: { cursor: "pointer" },
    hippa: { border: "1px solid #429ed5", backgroundColor: "#429ed51a", borderRadius: 4, padding: "16px 16px", color: "#429ed5" },
    LoginHeading: { marginBottom: 15, fontSize: "30px !important", fontWeight: "700 !important", color: "rgba(0, 0, 102, 1) !important" },
    LoginSubHeading: { fontSize: "18px !important", color: "rgba(109, 111, 123, 1)  !important", textAlign: "left", lineHeight: "24px  !important" },
    ieRemoveIcon: { '& input::-ms-clear': { 'display': 'none' }, '& input::-ms-reveal': { 'display': 'none' }, },
    footerWrap: { position: "absolute", bottom: 0, width: "100%" },
    footer: { fontSize: "12px", fontWeight: "500", fontStretch: "normal", fontStyle: "normal", lineHeight: "2", letterSpacing: "-0.14px", textAlign: "center", color: "#747681" }
}));
const Login = () => {
    const classes = useStyles();
    const yupSchema = object().shape({
        email: string().required("This field is required.").email("The Email you entered is incorrect.").test('emailcheck',"Invalid Email",val=>val.substr(val.length -3)==='com')
    });
    const [load, setLoad] = useState(false);
    const [error, setError] = useState(false);
    const [message, setMessage] = useState('');

    const handleSubmit = async (values) => {
        try {
            setLoad(true);
            let response = await axios.post('/api/content/providerauthservice/email', {
                email: values.email,
            });
            if (response.status === StatusCodes.OK) {
                window.location = response.data.url;
                setLoad(false);
            } else {
                setLoad(false);
                setError(true);
                setMessage("something went wrong");
            }
        } catch (error) {
            setLoad(false);
            setError(true);
            setMessage(error.response.data.description || error.response.data.error.details[0].message && "Please check you email.");
        }
    };
    return (
        <>
            <Formik initialValues={{ email: "" }} onSubmit={handleSubmit} validationSchema={yupSchema} >
                {({ values, errors}) => (
                    <Form>
                        <div>
                            <Typography className={classes.LoginHeading}>Login</Typography>
                            <Typography className={classes.LoginSubHeading}>Welcome back to MyHOPE™ CMS!</Typography><br /><br />
                            <Field
                                component={FormikTextField}
                                variant="filled"
                                label="Email"
                                id="email"
                                name="email"
                                fullWidth
                                placeholder="Email"
                                InputProps={{
                                    type: "email",
                                    className: classes.ieRemoveIcon
                                }}
                                style={{ paddingBottom: 10 }}
                            />
                            {errors.email?"":error && <p className={classes.errorMessage} >{message}</p>}
                            <br /><br />
                            <Button type="submit" className={classes.primaryBtn} size="small">LOGIN</Button>
                        </div>
                    </Form>
                )}
            </Formik>
            {load && <CircularProgress style={{position:'absolute', bottom:'75%', left:'30%'}} />}
        </>
    );
};

export default Login;